import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/finally';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/of';

// References:
// http://stackoverflow.com/questions/37316156/how-to-debounce-user-input-in-reactjs-using-rxjs
// https://www.learnrxjs.io/

// Somewhat relevant ones:
// http://shuheikagawa.com/blog/2016/05/01/incremental-search-with-rxjs/
// http://stackoverflow.com/questions/34520598/how-to-use-subject-and-debounce-with-rxjs-5-from-a-string-input
// https://gist.github.com/btroncone/d6cf141d6f2c00dc6b35


export class RxSubjRegistrar {
  constructor() {
    this.subjects = {};
  }

  reset() {
    for (const key of Object.keys(this.subjects)) {
      delete this.subjects[key];
    }
  }

  // Ensure there's a corresponding subject for key
  callViaSubj(key, setupFunc, onNextFunc, args) {
    let subj = this.subjects[key];

    // Set up subject if the first time.
    if (typeof subj === 'undefined') {
      subj = new Subject();
      subj.finally(() => {
        delete this.subjects[key];
      });
      this.subjects[key] = subj;
      setupFunc(subj, onNextFunc);
    }

    subj.next(args);
  }

  // Call next with args if subject available; otherwise noop.
  castViaSubj(key, args) {
    const subj = this.subjects[key];
    if (typeof subj === 'undefined') {
      return;
    }

    subj.next(args);
  }
}


export function makeFuncDebounceSwitchMapViaRxSubj(time = 400) {
  return function debounceSwitchMapViaRxSubj(subject, onNextFunc) {
    return subject.debounceTime(time)
                  .switchMap(args => Observable.of(args))
                  .subscribe(onNextFunc);
  };
};



// WEBPACK FOOTER //
// ./src/shared/helpers/rxHelper.js